import { render, staticRenderFns } from "./AdminDashboardBigCalendar.vue?vue&type=template&id=54fd6b64&scoped=true&"
import script from "./AdminDashboardBigCalendar.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardBigCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fd6b64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VSheet})
